import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict'

const formatDistanceLocale: Record<string, (count: number) => string> = {
  lessThanXSeconds: c => `now`,
  xSeconds: c => `now`,
  halfAMinute: () => 'now',
  lessThanXMinutes: c => `${c}m`,
  xMinutes: c => `${c}m`,
  aboutXHours: c => `${c}h`,
  xHours: c => `${c}h`,
  xDays: c => `${c}d`,
  aboutXWeeks: c => `${c}w`,
  xWeeks: c => `${c}w`,
  aboutXMonths: c => `${c}m`,
  xMonths: c => `${c}m`,
  aboutXYears: c => `${c}y`,
  xYears: c => `${c}y`,
  overXYears: c => `${c}y`,
  almostXYears: c => `${c}y`
}

export function formatDistanceToNowCustom(date: Date) {
  return formatDistanceToNowStrict(date, {
    locale: { formatDistance: (token, count) => formatDistanceLocale[token](count) }
  })
}
